import React, { useState } from "react";

const AutocompleteInput = ({
  handleChange,
  filteredSuggestions,
  handleSelectSuggestion,
  inputClass,
  value
}) => {
  const [query, setQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const handleBlur = () => {
    // Delay hiding the suggestions to allow click events to be processed
    setTimeout(() => {
      setIsFocused(false);
    }, 200); // Adjust delay time if necessary
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  return (
    <div className="relative w-full">
      <input
        type="text"
        value={value}
        onChange={(e) => {
          const value = e.target.value;
          setQuery(value);
          handleChange(value);
        }}
        onBlur={handleBlur}
        onFocus={handleFocus}
        placeholder="Search..."
        className={`py-3 px-2 text-sm border-2 border-gray-300 rounded-lg focus:outline-none !focus-visible:border-none focus:ring-0 focus:border-[#2BACE2] ${inputClass}`}
      />

      {/* Show suggestions only when input is focused and there are suggestions */}
      {isFocused && filteredSuggestions.length > 0 && (
        <ul className="absolute left-0 right-0 top-[35px] z-10 max-h-40 overflow-y-auto rounded bg-white shadow-md">
          {filteredSuggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => {
                handleSelectSuggestion(suggestion);
                setIsFocused(false);
              }}
              className="cursor-pointer border-b border-gray-200 px-3 py-2 hover:bg-gray-100 last:border-b-0"
            >
              {suggestion?.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutocompleteInput;
